import React, { useEffect } from 'react';
import { TableColumn } from 'react-data-table-component';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import { RootState } from 'app/store';
import { Project } from '../models';
import { HttpClientError, RequestStatus } from 'http-client';
import {BiEditAlt} from "react-icons/bi";
import {MdOutlineDeleteForever} from "react-icons/md";
import {deleteProject, getList, reset, setSingle} from "../project.reducer";
import {deletedStatusOption, deletedWarnOption} from "../../../../helpers/alertLabel";
import DataTableServerPaging from "../../../../components/Table/DataTableServerPaging";

const ProjectTable = ({ ...props}: ProjectTableProps) => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);

    const rows = useAppSelector((state: RootState) => state.project.rows ?? 0);
    const projectList = useAppSelector(
        (state: RootState) => state.project.list ?? []
    );
    const status = useAppSelector((state: RootState) => state.project.status);
    const error = useAppSelector(
        (state: RootState) => state.project.error ?? ({} as HttpClientError)
    );

    useEffect(() => {
        dispatch(getList({ skip: 0, take: 10 }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (status !== undefined && status !== RequestStatus.pending) {
            MySwal.fire(deletedStatusOption(status === RequestStatus.success, error.data?.message)).then(() => {
                dispatch(reset());
                dispatch(getList({ skip: 0, take: 10 }));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, error]);

    const openFormModal = (single: Project) => {
        props.openModal(true);
        dispatch(setSingle(single));
    }

    const onDeleteClicked = (id: string) => {
        MySwal.fire(deletedWarnOption).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteProject(id));
            }
        });
    };

    const columns: TableColumn<Project>[] = [
        {
            name: 'NO.',
            width: '60px',
            cell: (_d: any, index: number) => index + 1,
        },
        {
            name: 'Name',
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: 'District',
            cell: (row) => (
                <>
                    <span>
                    {row.district_list?.map((district, index) => {
                       return district.name + (index === row.district_list?.length -1 ? '' : ', ')
                    })}
                    </span>
                </>
            ),
            sortable: true,
        },
        {
            name: 'Action',
            width: '220px',
            cell: (row) => (
                <>
                    <button
                        onClick={() => openFormModal(row)}
                    >
                        <BiEditAlt className="mr-2 text-2xl text-primary-color" />
                    </button>
                    <button onClick={() => onDeleteClicked(row.id)}>
                        <MdOutlineDeleteForever className="mr-2 text-2xl text-secondary-color"  />
                    </button>
                </>
            ),
        },
    ];

    const handlePagingChange = (rowsPerPage: number, page: number) => {
        dispatch(
            getList({
                skip: rowsPerPage * (page - 1),
                take: rowsPerPage,
            })
        );
    }

    return (
        <div className="main-data-grid mt-5">
            <DataTableServerPaging columns={columns} data={projectList} rows={rows} handlePagingChange={handlePagingChange} />
        </div>
    );
};

export interface ProjectTableProps {
    openModal: (isEdit: boolean) => void;
}

export default ProjectTable;